import React, { useCallback, useEffect, useState,useContext } from "react";
import Http from "../../../../networkReq/http";
import Request from "../../../../networkReq/request";
import { useHistory } from "react-router-dom";
import { NavConText } from "../index";
import {
  Card,
  Pagination,
  Button,
  ConfigProvider,
  Input,
  Select,
  Form,
  Row,
  Col,
  message
} from "antd";
import JobItem from "../jobCollection/JobItem";
import "./index.scss";
import "../index.scss";
import zh_CN from "antd/es/locale/zh_CN";
import Collected from "images/collected.png";
import CollectWork from "images/collectWork.png";
const { Option } = Select;
const { Search } = Input;

function itemRender(current, type, originalElement) {
  if (type === "prev") {
    return <a>上一页</a>;
  }
  if (type === "next") {
    return <a>下一页</a>;
  }
  return originalElement;
}

export default function JobCollection(props) {
  const { setNavShow } = useContext(NavConText)
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchValue, setSearchValue] = useState("");
  const [selectValue, setSelectValue] = useState("");
  const [deliveryTime, setDeliveryTime] = useState("0");
  const [succeed, setSucceed] = useState(0); //收藏
  const [succeedTwo, setSucceedTwo] = useState(0); //收藏
  let params = {
    size: 5,
    current: currentPage,
    text: selectValue,
    time: deliveryTime,
  };
  const [total, setTotal] = useState(0);

  const handlePage = useCallback((page, pageSize) => {
    setCurrentPage(page);
  }, []);
  //顶部下拉框hanle函数
  const handleSelectTime = useCallback((value) => {
    console.log("valuevalue", value);
    setDeliveryTime(value);
    //
  }, []);
  // 顶部搜索框hanle函数
  const handleChangeSearchValue = useCallback((e) => {
    setSearchValue(e.target.value);
  }, []);
  //搜索框点击搜索handle
  const handleSearch = useCallback((val) => {
    setSelectValue(val);
    // 这里dispatch  获取后台数据
  }, []);

  const initiaList = () => {
    Http.get(Request.personageResume(), { ...params }, (obj) => {
      setData(obj.data?.records || []);
      setTotal(obj.data?.total || []);
    });
  }; 
  const collect = useCallback((id, collect) => {
    //收藏方法和取消收藏方法
    console.log("collectcollect", collect);
    if (collect == 0) {
      Http.get(Request.collectList(), { id: id }, (obj) => {
        if (obj.code == 200) {
          setSucceed(id);
          setSucceedTwo(collect);
          message.success("收藏成功", 2);
        }
      });
    } else {
      Http.get(Request.cancelCollectList(), { id: id }, (obj) => {
        if (obj.code == 200) {
          setSucceed(id);
          setSucceedTwo(collect);
          message.success("取消成功", 2);
        }
      });
    }
  }, []);
  useEffect(() => {
    initiaList();
  }, [currentPage, selectValue, deliveryTime, succeed, succeedTwo]);

  const history = useHistory();
  const handleJobDetail = useCallback((id) => {
    history.push(`/entrance/personal/myDelivery/detail/${id}`);
  }, [history]);

  return (
    <div className="my_delivery_job_item_box">
      <div style={{ padding: "16px 24px", background: "#fff" }}>
        <Form layout="inline">
          <Row style={{ width: "100%" }}>
            <Col style={{ flex: 1 }}>
              <Form.Item
                label={<span className="form_item_label">职位名称</span>}
              >
                <Search
                  placeholder="职位名称"
                  onChange={handleChangeSearchValue}
                  style={{ flex: 1 }}
                  value={searchValue}
                  onSearch={handleSearch}
                />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item
                label={<span className="form_item_label">投递时间</span>}
              >
                <Select
                  defaultValue={deliveryTime}
                  style={{ width: 240 }}
                  onChange={handleSelectTime}
                >
                  <Option value="1">一周内</Option>
                  <Option value="2">一个月内</Option>
                  <Option value="0">全部时间</Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>
      {data.map((item, index) => {
        return (
          <JobItem job={item} key={index} handleJobDetail={handleJobDetail} />
        );
      })}
      <ConfigProvider locale={zh_CN}>
        <Pagination
          total={total}
          itemRender={itemRender}
          showQuickJumper={{
            goButton: <Button className={"pagination_jump"}>确定</Button>,
          }}
          showTotal={(total) => `共 ${total} 条`}
          onChange={handlePage}
          showSizeChanger={false}
          current={currentPage}
          defaultPageSize={5}
          style={{
            marginTop: 14,
            paddingRight: 24,
            display: "flex",
            justifyContent: "flex-end",
          }}
        />
      </ConfigProvider>
    </div>
  );
}
